import PermissionService from '@/services/PermissionService';

export default {
  methods: {
    /**
     * Verifica si un campo está deshabilitado según permisos
     * @param {string} domain - Dominio del campo (ej. "Location")
     * @param {string} field - Clave del campo (ej. "email")
     * @param {string|array} actions - Acción o acciones a verificar
     * @returns {boolean} - True si el campo debe estar deshabilitado
     */
    isFieldDisabled(domain, field, actions = 'write') {
      return PermissionService.isFieldDisabled(domain, field, actions);
    },
    
    /**
     * Verifica si un campo debe ocultarse según permisos
     * @param {string} domain - Dominio del campo
     * @param {string} field - Clave del campo
     * @param {string|array} actions - Acción o acciones a verificar
     * @returns {boolean} - True si el campo debe ocultarse
     */
    shouldHideField(domain, field, actions = 'read') {
      return PermissionService.isFieldDisabled(domain, field, actions);
    },
    
    /**
     * Verifica si un usuario puede realizar una o más acciones
     * @param {string} domain - Dominio del campo
     * @param {string} field - Clave del campo
     * @param {string|array} actions - Acción o acciones a verificar
     * @param {string} mode - Modo de verificación: 'any' o 'all'
     * @returns {boolean} - True si el usuario tiene los permisos necesarios
     */
    canPerformActions(domain, field, actions = 'write', mode = 'any') {
      return PermissionService.canPerformActions(domain, field, actions, mode);
    },
    
    /**
     * Obtiene las props de un campo considerando los permisos
     * @param {string} domain - Dominio del campo
     * @param {string} field - Clave del campo
     * @param {string|array} actions - Acción o acciones a verificar
     * @param {Object} baseProps - Props base a extender
     * @returns {Object} - Props con estado disabled según permisos
     */
    getFieldProps(domain, field, actions = 'write', baseProps = {}) {
      const isDisabled = this.isFieldDisabled(domain, field, actions);
      
      return {
        ...baseProps,
        disabled: isDisabled || baseProps.disabled
      };
    },
    
    /**
     * Obtiene los estados de permisos para un campo y múltiples acciones
     * @param {string} domain - Dominio del campo
     * @param {string} field - Clave del campo
     * @param {Array} actions - Lista de acciones a verificar
     * @returns {Object} - Mapa de acción -> permiso concedido
     */
    getPermissionStates(domain, field, actions = ['write', 'read', 'delete']) {
      const result = {};
      
      actions.forEach(action => {
        result[action] = !PermissionService.isFieldDisabled(domain, field, action);
      });
      
      return result;
    },
    
    /**
     * Aplica restricciones de permisos a un elemento del DOM
     * Útil para aplicar manualmente las restricciones
     * @param {HTMLElement} el - Elemento DOM
     * @param {boolean} isDisabled - Si debe estar deshabilitado
     */
    applyFieldPermission(el, isDisabled) {
      if (!el) return;
      
      if (isDisabled) {
        // Para elementos HTML normales
        el.setAttribute('disabled', 'true');
        el.classList.add('disabled', 'v-input--is-disabled');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.6';
        
        // Deshabilitar cualquier input anidado
        const inputs = el.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
          input.setAttribute('disabled', 'true');
        });
      }
    }
  }
};
